/* Scroll-reveal: adds .is-visible to .reveal elements via IntersectionObserver.
   Staggers by 60ms per index inside a .reveal-group, capped at the 6th item. */
(function () {
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function stageIndexes(root) {
    var groups = root.querySelectorAll('.reveal-group');
    groups.forEach(function (group) {
      var items = group.querySelectorAll(':scope > .reveal');
      items.forEach(function (el, i) {
        if (!el.style.getPropertyValue('--reveal-i')) {
          el.style.setProperty('--reveal-i', Math.min(i, 6));
        }
      });
    });
  }

  function init(root) {
    root = root || document;
    stageIndexes(root);

    if (prefersReduced) {
      root.querySelectorAll('.reveal').forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
          }
        });
      },
      { root: null, rootMargin: '0px 0px -10% 0px', threshold: 0.15 }
    );

    root.querySelectorAll('.reveal:not(.is-visible)').forEach(function (el) {
      observer.observe(el);
    });

    window.MesaMayor = window.MesaMayor || {};
    window.MesaMayor.revealObserver = observer;
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });

  /* Re-scan after Ajax content is appended (collection "ver más", cart drawer, etc). */
  document.addEventListener('mesamayor:content-updated', function (e) {
    init(e.detail && e.detail.root ? e.detail.root : document);
  });
})();
